window.OSM = window.OSM ?? {};
/**
 * @type {IMapsProps}
 */
OSM.MapConfigs = OSM.MapConfigs ?? {}

/**
 * See MapCoreConfig.js for working example
 * @type {IMapProps}
 */
OSM.MapConfigs.default = {

}

/**
 * @type {IMapProps}
 */
OSM.MapConfigs.our_locations = {
    singleMarkerIsPrimaryMarker: false,
    cluster: {

        marker: {
            lngLat: [0, 0],
            iconProps: {
                imagePath: "/app/themes/hailstone/img/layout/icon-navy.png",
                imageIconTopLeftAdditionalOffset: [-3, 3],
                imageIconBottomRightAdditionalOffset: [3, -3]
            }
        },
        source: {
            clusterRadius: 20,
            type: undefined,
            data: undefined
        }
    }
}

OSM.MapConfigs.globe_test = {
    projectionType: "globe",
    preferredMapFocus: "defined",
    mapOptions: {
        center: [-6.3151059, 54.160318],
        zoom: 3
    },
}